"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceTotal = void 0;
const Section_1 = __importDefault(require("@/components/layout/Section"));
const SpecificHeader_1 = require("@/components/layout/SpecificHeader");
const fetchData_1 = require("@/utils/fetchData");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importStar(require("styled-components"));
const Overview_1 = __importDefault(require("./sections/Overview"));
const themes_1 = require("@/theme/themes");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const SimpleTable_1 = __importDefault(require("@/components/list/SimpleTable"));
const format_1 = require("@/utils/format");
const material_1 = require("@mui/material");
const styledComponents_1 = require("@/components/styledComponents");
const AccountIdBox_1 = __importDefault(require("@/components/layout/AccountIdBox"));
const Card_1 = require("@/components/dataCard/Card");
const Amount_1 = __importStar(require("@/components/layout/Amount"));
const principalToAccountId_1 = require("@/utils/principalToAccountId");
const GovernanceAccountSpecific = () => {
    const params = (0, react_router_dom_1.useParams)();
    const [balance, setBalance] = (0, react_1.useState)(null);
    const [ledgerBalance, setLedgerBalance] = (0, react_1.useState)(0);
    const [governanceBalance, setGovernanceBalance] = (0, react_1.useState)(null);
    const [assets, setAssets] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [stakesList, setStakesList] = (0, react_1.useState)();
    const [vestingsList, setVestingsList] = (0, react_1.useState)();
    const isDarktheme = (0, react_router_dom_1.useOutletContext)();
    const getData = async () => {
        try {
            const result = await Promise.all([
                (0, fetchData_1.getGovernanceBalanceById)(params.id),
                (0, fetchData_1.getGovernanceAssetsById)(params.id),
                (0, fetchData_1.getStakesByPrincipal)(params.id),
                (0, fetchData_1.getLedgerTimeseriesById)((0, principalToAccountId_1.getAccountIdFromString)(params.id)),
            ]);
            const [balanceResult, governanceAssetsResult, stakesListResult, timeseriesResult] = await Promise.all(result);
            setBalance(balanceResult), setAssets(governanceAssetsResult);
            setLedgerBalance(timeseriesResult.balance[timeseriesResult.balance.length - 1].balance || 0);
            setGovernanceBalance(balanceResult.data[0].value);
            setStakesList(stakesListResult.stakes);
            setVestingsList(stakesListResult.vestings);
            setIsLoading(false);
        }
        catch (e) {
            console.log(e);
        }
    };
    (0, react_1.useEffect)(() => { }, [assets]);
    (0, react_1.useEffect)(() => {
        getData();
    }, []);
    return (react_1.default.createElement(origyn_art_ui_1.Container, { padding: '48px', mdPadding: '24' },
        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: isDarktheme ? themes_1.darkTheme : themes_1.lightTheme },
            react_1.default.createElement(Section_1.default, null, balance && (react_1.default.createElement(material_1.Box, { sx: { gridColumn: 'span 12' } },
                react_1.default.createElement(SpecificHeader_1.PageTypeTitle, null, "Account Balance Details"),
                react_1.default.createElement("br", null),
                react_1.default.createElement(styledComponents_1.GridContainer, null,
                    react_1.default.createElement(SpecificHeader_1.CellBox, { col: 3 },
                        react_1.default.createElement(SpecificHeader_1.IdLabel, null, "Principal ID"),
                        react_1.default.createElement(AccountIdBox_1.default, { id: params.id, label: params.id, path: null, isNotLink: true, maxWidth: 400 }),
                        balance.title && react_1.default.createElement(styledComponents_1.Tag, null, balance.title)),
                    react_1.default.createElement(SpecificHeader_1.CellBox, { col: 3 },
                        react_1.default.createElement(Card_1.Card, { amountSize: Amount_1.AmountSize.Small, data: {
                                title: "Total Balance",
                                value: governanceBalance + ledgerBalance
                            }, bg: "contrastBg" })),
                    react_1.default.createElement(SpecificHeader_1.CellBox, { col: 3 },
                        react_1.default.createElement(Card_1.Card, { amountSize: Amount_1.AmountSize.Small, data: {
                                title: "Governance balance",
                                value: governanceBalance
                            }, bg: "contrastBg" })),
                    react_1.default.createElement(SpecificHeader_1.CellBox, { col: 3 },
                        react_1.default.createElement(Card_1.Card, { amountSize: Amount_1.AmountSize.Small, data: {
                                title: "Ledger Balance",
                                value: ledgerBalance
                            }, bg: "contrastBg" }))),
                react_1.default.createElement("br", null),
                react_1.default.createElement(SpecificHeader_1.PageTypeTitle, null, "Governance Balance Details"),
                react_1.default.createElement("br", null),
                react_1.default.createElement(styledComponents_1.GridContainer, null,
                    react_1.default.createElement(SpecificHeader_1.CellBox, { col: 3 },
                        react_1.default.createElement(Card_1.Card, { amountSize: Amount_1.AmountSize.Small, data: {
                                title: "Estimate tokens in governance",
                                value: balance?.data[0].value,
                            }, bg: "contrastBg" })),
                    balance?.data[0].children?.map((e, i) => {
                        if (e) {
                            return (react_1.default.createElement(SpecificHeader_1.HeaderCard, { col: 3, sx: { height: '100%' } },
                                e.label && react_1.default.createElement(material_1.Box, null, e.label),
                                e.name && react_1.default.createElement(material_1.Box, null, e.name),
                                e.title && react_1.default.createElement(material_1.Box, null, e.title),
                                react_1.default.createElement(Amount_1.default, { amount: (0, format_1.formatAmount)(e.value), size: Amount_1.AmountSize.Small })));
                        }
                    }))))),
            react_1.default.createElement(Section_1.default, null,
                react_1.default.createElement(Overview_1.default, { data: balance?.data.slice(1), isPageLoading: isLoading })),
            stakesList?.data?.length ? react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Section_1.default, { isLoading: isLoading, title: "OGY stakes in governance", tooltip: "List of OGY token stakes and their amount." },
                    react_1.default.createElement(SimpleTable_1.default, { colWidth: {
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }, isPageLoading: isLoading, initData: stakesList, dataKey: 'stakes', dataFetching: () => (0, fetchData_1.getStakesByPrincipal)(params.id) }))) : react_1.default.createElement(react_1.default.Fragment, null),
            vestingsList?.data?.length ? react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Section_1.default, { isLoading: isLoading, title: "OGY vestings", tooltip: "List of OGY token vestings and their amount." },
                    react_1.default.createElement(SimpleTable_1.default, { colWidth: {
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }, isPageLoading: isLoading, initData: vestingsList, dataKey: 'vestings', paramKey: "id", noPagination: true, dataFetching: () => (0, fetchData_1.getStakesByPrincipal)(params.id) }))) : react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.default = GovernanceAccountSpecific;
exports.BalanceTotal = (0, styled_components_1.default)('h3') `
  padding-bottom: 5px;
  margin-bottom: 3px;
`;
